import styled from 'styled-components';

// Matches asset-hierarchy FamilyLines: #999B95 + dasharray 3.
const TREE_LINE = '#999B95';
const TREE_DASH = `1px dashed ${TREE_LINE}`;
const GREEN = '#00A651';

// Outer panel: width-constrained; breadcrumb dropdowns still escape via absolute
// positioning relative to PillRow (not clipped by ScrollArea).
export const PanelContainer = styled.div`
  height: 100%;
  width: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  background: white;
`;

export const ScrollArea = styled.div`
  flex: 1;
  min-height: 0;
  min-width: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 4px 0 12px 0;
`;

export const SectionTitle = styled.div`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #9aa0a9;
  padding: 10px 12px 4px 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const EmptyMsg = styled.div`
  padding: 16px 12px;
  font-size: 13px;
  color: #9aa0a9;
`;

// Org (or site-group) root — same visual weight as the site root in asset hierarchy.
export const TreeRoot = styled.div`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-height: 30px;
  padding: 4px 12px 4px 14px;
  font-size: 12px;
  font-weight: 700;
  font-family: 'Petasense Open Sans';
  color: #3C3D3A;
  cursor: ${props => (props.clickable ? 'pointer' : 'default')};
  user-select: none;

  .icon {
    display: inline-flex;
    align-items: center;
    margin-right: 8px;
    flex-shrink: 0;
  }

  .name {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &:hover {
    ${props => props.clickable && `color: ${GREEN};`}
  }
`;

// Site child row under the org root. Dotted spine + elbow match HierarchyNodeItem
// FamilyLines (stroke #999B95, dasharray 3).
export const TreeSiteRow = styled.div`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  position: relative;
  width: 100%;
  max-width: 100%;
  min-height: 30px;
  padding: 4px 12px 4px 46px;
  font-size: 12px;
  font-weight: ${props => (props.selected ? 700 : 600)};
  font-family: 'Petasense Open Sans';
  color: ${props => (props.selected ? GREEN : '#3C3D3A')};
  cursor: pointer;
  user-select: none;

  .text {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .count {
    flex-shrink: 0;
    margin-left: 8px;
    font-size: 11px;
    font-weight: 500;
    color: ${props => (props.selected ? GREEN : '#9aa0a9')};
  }

  /* Vertical spine */
  &::before {
    content: '';
    position: absolute;
    left: 22px;
    top: 0;
    bottom: 0;
    border-left: ${TREE_DASH};
  }

  &.last-site::before {
    bottom: 50%;
  }

  /* Horizontal elbow into the row */
  &::after {
    content: '';
    position: absolute;
    left: 22px;
    top: 50%;
    width: 16px;
    border-top: ${TREE_DASH};
  }

  &:hover {
    color: ${GREEN};
    background-color: #f7f7f7;
  }

  &:hover .count {
    color: ${GREEN};
  }
`;

export { TREE_LINE };
